export const VALID_RELATIONSHIPS = ['Mother', 'Brother', 'Daughter', 'Father', 'Husband', 'Sister', 'Son', 'Wife', 'Daughter-in-law', 'Father-in-law', 'Mother-in-law', 'Son-in-law', 'Spouse', 'Others', 'Partner', 'Child', 'Friend'];

export const VALID_GENDERS = ['Male', 'Female', 'Other'];

export const DEFAULT_CONSENT_STEPS = ['review', 'additionalMembers', 'otp', 'payment'];
